/**
 * BreadcrumbPrefix
 * 
 * @Author: Focci
 * @Date: 2024-01-16 14:41:50
 * @Last Modified by: Focci
 * @Last Modified time: 2024-01-16 14:41:50
 */

import PropTypes from 'prop-types'
import RouteBack from './RouteBack'
import BreadcrumbSearchBar from './search-bar'

export default function BreadcrumbPrefix({
  house
}) {
  return (
    <div className="flex items-center gap-x-2 pr-2">
      <RouteBack
        type={house.type} 
        suburbName={house.suburbName} 
        suburbId={house.suburbId}
        className="text-c66" 
      />
      <BreadcrumbSearchBar type={house.type} />
    </div>
  )
}

BreadcrumbPrefix.propTypes = {
  house: PropTypes.string,
}
